import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import { Attachment } from '../components/AttachmentUpload/types';
import { GetTemplatesResponse, SendTemplateResponse } from './types';

export const sendSaveTemplatesRequests = async (attachments: Attachment[]) => {
    const { userId, organizationId } = getContext();
    if (!userId || !organizationId) {
        const error = new Error(
            `Attempting to save documents for non authenticated user: ${userId} organization: ${organizationId}`
        );
        logger.error(error);
        throw new Error();
    }
    return axios.post(pathfinder('create_legal_document_template'), attachments);
};

export const fetchTemplates = async (
    userId?: string | number,
    organizationId?: string,
    options?: {
        SSR_URL?: string;
        withUsage?: boolean;
        withInactive?: boolean;
    }
): Promise<GetTemplatesResponse> => {
    userId = userId || getContext().userId;
    organizationId = organizationId || getContext().organizationId;

    if (!userId || !organizationId) {
        const error = new Error(
            `Attempting to fetch documents for non authenticated user: ${userId} organization: ${organizationId}`
        );
        logger.warn(error);
        throw new Error();
    }

    const path = options?.SSR_URL
        ? `${options?.SSR_URL}${pathfinder('get_legal_document_templates')}`
        : pathfinder('get_legal_document_templates');
    const { data } = await axios.get<GetTemplatesResponse>(path, {
        params: {
            with_usage: options?.withUsage ?? true,
            with_inactive_templates: options?.withInactive,
        },
    });
    return data;
};

export const sendTemplates = async (sellerId: number, templateIds: string[]): Promise<SendTemplateResponse> => {
    const { userId, organizationId } = getContext();
    if (!userId || !organizationId) {
        const error = new Error(
            `Attempting to send documents for non authenticated user: ${userId} organization: ${organizationId}`
        );
        logger.warn(error);
        throw new Error();
    }

    const result = await axios.post<SendTemplateResponse>(pathfinder('send_legal_document'), {
        seller_id: sellerId,
        template_ids: templateIds,
    });
    return result?.data;
};

export const requestTemplateUpload = async (adminId: number, requestText?: string) =>
    axios.post(pathfinder('request_legal_document_templates'), { requestText, adminId });

export const updateDoNotShowAgainModal = async () => axios.put(pathfinder('hide_legal_document_modal'));
